export default __webpack_public_path__ + "static/media/MyLittlePony_04.79cbb6aa.png";